import { AuthService } from "./auth";
import { BackendService } from "./backend";
import { CacheService } from "./cache";
export function initServices() {
    const backend = new BackendService();
    const auth = new AuthService(backend);
    const cache = new CacheService(backend);
    return { auth, backend, cache };
}
